import { Routes } from '@angular/router';
import { EditorComponent } from './editor/editor.component';
import { LoginComponent } from './login/login.component';
import { AuthGuard } from './login/auth-guard.service';
import { ProjectListComponent } from './project/project-list/project-list.component';
import { ProjectComponent } from './project/project.component';
import { ProjectEditComponent } from './project/project-edit/project-edit.component';
import { VariantComponent } from './variant/variant.component';
import { VariantListComponent } from './variant/variant-list/variant-list.component';
import { WagonViewComponent } from './wagon/wagon.component';
import { WagonViewListComponent } from './wagon/wagon-list/wagon-list.component';
import { WagonViewEditComponent } from './wagon/wagon-edit/wagon-edit.component';
import { EvaluationComponent } from './evaluation/evaluation.component';
import { CompanyComponent } from './company/company.component';
import { CompanyListComponent } from './company/company-list/company-list.component';
import { CompanyEditComponent } from './company/company-edit/company-edit.component';
import { DatamanagementComponent } from './datamanagement/datamanagement.component';
import { DatamanagementListComponent } from './datamanagement/datamanagement-list/datamanagement-list.component';
import { DatamanagementDetailsComponent } from './datamanagement/datamanagement-details/datamanagement-details.component';
import { UsermanagementComponent } from './usermanagement/usermanagement.component';
import { UsermanagementListComponent } from './usermanagement/usermanagement-list/usermanagement-list.component';
import { CanDeactivateGuard } from './services/deactivateGuard.service';
import { EvaluationSelectionComponent } from './evaluation/evaluation-selection/evaluation-selection.component';
import { EvaluationTrainComponent } from './evaluation/evaluation-train/evaluation-train.component';
import { EvaluationVariantComponent } from './evaluation/evaluation-variant/evaluation-variant.component';
import { TrainComponent } from './train/train.component';
import { TrainListViewComponent } from './train/train-list-view/train-list-view.component';

export const routes: Routes = [
    { path: '', redirectTo: '/login', pathMatch: 'full'},
    { path: 'login', component: LoginComponent },
    {
      path: 'company', component: CompanyComponent, canActivate: [AuthGuard], children:
        [{ path: 'list', component: CompanyListComponent }
          , { path: 'edit/:id', component: CompanyEditComponent, canDeactivate: [CanDeactivateGuard] }]
    },
    { path: 'editor/:waggonId/:variantId', component: EditorComponent, canActivate: [AuthGuard], canDeactivate: [CanDeactivateGuard] },
    {
      path: 'user', component: UsermanagementComponent, canActivate: [AuthGuard], children:
        [{ path: 'list', component: UsermanagementListComponent }]
    },
    {
      path: 'project', component: ProjectComponent, canActivate: [AuthGuard], children:
        [{ path: 'list', component: ProjectListComponent }
          , { path: 'edit/:id', component: ProjectEditComponent, canDeactivate: [CanDeactivateGuard] }]
    },
    {
      path: 'wagon', component: WagonViewComponent, canActivate: [AuthGuard], children:
        [{ path: 'list/:id', component: WagonViewListComponent }
          , { path: 'edit/:projectId/:waggonId', component: WagonViewEditComponent, canDeactivate: [CanDeactivateGuard] }]
    },
    {
      path: 'layout', component: VariantComponent, canActivate: [AuthGuard], children:
        [{ path: 'list/:projectId/:waggonId', component: VariantListComponent }]
    },
    {
      path: 'evaluation', component:EvaluationComponent,canActivate: [AuthGuard], children:[
        {
          path: 'selection', component: EvaluationSelectionComponent
        },
        {
          path: 'train', component: EvaluationTrainComponent
        },
        {
          path: 'variant', component: EvaluationVariantComponent
        },
      ]
    },
    {
      path: 'train', component: TrainComponent, canActivate: [AuthGuard]
      , children:
        [{ path: 'list/:id', component: TrainListViewComponent }
        ]
    },
    {
      path: 'datamanagement', component: DatamanagementComponent, canActivate: [AuthGuard], children:
        [{ path: 'list', component: DatamanagementListComponent },
        { path: 'view/:isEditor/:regionId', component: DatamanagementDetailsComponent, canDeactivate: [CanDeactivateGuard] }]
    },
    { path: '**', redirectTo: '' }
  
  ];